import React from 'react';
import { Flex, Toast, theme, Text } from '@xometry/xometry_loft';
import { css } from '@emotion/react';

const WarningToast = () => {
  return (
    <Toast kind="warning" isOpen={true} hideClose={true}>
      <Flex gap={theme.space[2]}>
        <div>
          <i
            className="fa-solid fa-circle-exclamation"
            css={css`
              color: ${theme.colors.yellows[125]};
            `}
          />
        </div>
        <div>
          <div>
            {' '}
            <Text kind="label" color={theme.colors.darkBlues[100]}>
              {' '}
              Quote Presets can only be managed by Admins.
            </Text>
          </div>
          <div>
            <Text kind="body-sm">
              Contact an Admin to update these details or your level of access.
            </Text>
          </div>
        </div>
      </Flex>
    </Toast>
  );
};
export default WarningToast;
